<div id="error-container">
	<img src="../../../css/images/oops.png" title="Oops..." />

	<div>
		<p>Hmm... It looks like something went horribly wrong...</p>
		<p>Please contact the administrators if the problem persists!</p>

		<a class="btn btn-raised btn-primary" routerLink="/Dashboard">Go home</a>
	</div>
</div>
